"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("stringUtils", function (diacriticsMap) {
  var stringUtils = {
    /**
     * Removes all html tags from given string
     * 
     * @param html
     * @return {string}
     */
    stripHtml: function stripHtml(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    /**
     * Escapes special html characters from given string.
     *
     * I.E : "Hello > Dolly" -> "Hello & gt; Dolly"
     */
    escapeHtml: function escapeHtml(str) {
      return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    },
    /**
     * Capitalizes given string.
     *
     * I.E : - "hello" -> "Hello"
     */
    capitalize: function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    /**
     * Repeats given `sequence` `count` times
     */
    repeatSequence: function repeatSequence(sequence, count) {
      return new Array(count + 1).join(sequence);
    },
    /**
     * Counts the number of occurrences of given char in given string.
     */
    countCharOccurencies: function countCharOccurencies(string, char) {
      var matches = string.match(new RegExp("[" + char + "]", "gi"));
      return matches && matches.length || 0;
    },
    /**
     * Returns the position of the `x`th occurrence of given `val` in given `string`
     */
    xIndexOf: function xIndexOf(val, string, x) {
      if (x <= string.split(val).length - 1) {
        var ot = string.indexOf(val);
        if (x > 1) {
          for (var i = 1; i < x; i++) {
            ot = string.indexOf(val, ot + 1);
          }
        }
        return ot;
      } else {
        return -1;
      }
    },
    /**
     * Remove all accents from given string, preserving case.
     * Technically, it use a static diacritics map, to mimic the role of a normalizer.
     */
    removeAccents: function removeAccents(str) {
      // see http://stackoverflow.com/questions/990904/javascript-remove-accents-diacritics-in-strings
      return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return diacriticsMap[a] || a;
      });
    },
    /**
     * Check if given containingTerm contains given searchTerm.
     * Test will be case insensitive, and ignore accents.
     *
     * I.E : 'Héllo'  contains 'ELLO'
     */
    containsIgnoringCaseAndAccents: function containsIgnoringCaseAndAccents(containingTerm, searchTerm) {
      if (containingTerm == null || searchTerm == null) {
        return false;
      }
      var st = stringUtils.removeAccents(searchTerm).toLowerCase(),
        ct = stringUtils.removeAccents(containingTerm).toLowerCase();
      return ct.indexOf(st) > -1;
    },
    /**
     * Urlify given string (aka makes it url friendly)
     *
     * I.E : 'Hello dolly' -> 'hello-dolly'
     *       'To/to' -> 'to-to'
     *       'éà' -> 'ea'
     *
     * @param str
     * @returns {string}
     */
    urlify: function urlify(str) {
      return stringUtils.removeAccents(str).replace(/ /g, '-').replace(/:/g, '-').replace(/\\/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9\-]+/g, '').replace(/-{2,}/g, '-').toLowerCase();
    }
  };
  return stringUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/stringUtils.js
// module id = 2765
// module chunks = 13